import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* externalCpdSagas() {
  yield mapSagasFromConfigurations('externalCpd')(configurations)
}

export default externalCpdSagas;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/sagas.js